import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { App as AntdApp, ConfigProvider } from "antd";
import "@ant-design/v5-patch-for-react-19";
import { unstableSetRender } from "antd";

unstableSetRender((node, container) => {
  container._reactRoot ||= createRoot(container);
  const root = container._reactRoot;
  root.render(node);
  return async () => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    root.unmount();
  };
});

const root = createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <ConfigProvider>
    <AntdApp>
      <App />
    </AntdApp>
  </ConfigProvider>
  // </React.StrictMode>
);
